define(function(require, exports, module) {
    'use strict';

    var Configuration = require('modules/configuration/configuration');

    module.exports = new Configuration();
});
